import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as classNames from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';

@withRouter
export class Summary extends React.Component<any, any> {

    constructor(props) {
        super(props);
    }

    render() {
        const { location, children, name, online, theme, ...props } = this.props;

        return (
            <div className="row small">
                <div className="col-1">
                    <i className={classNames("fa fa-circle", {"yellow-text": online})} aria-hidden="true"></i>
                </div>
                <div>
                    {name}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Member/Summary.tsx